import { ChartData } from "@models/Dashboard/chartData.model";
import { SensorReadingInfo } from "@models/EventLog/SensorReadingInfo.model";
import { GpsInfo } from "@models/Map/gpsInfo.model";
import { UserAccessType } from "@models/User/UserAccessType.model";
import { SensorReadingType } from "./sensorgroup.model";
import { TimeZoneDisplay } from "./TimeZone.model";
import { SensorSearchCondition } from "./sensorSearchCondition.model";
import { SensorCalibrationHistory, SensorCalibrationHistoryInfo } from "./sensorCalibrationHistory.model";

export interface Sensor {
    id: number;
    uuid: string;
    displayedSensorName?: string;
    sensorReadingTypes: SensorReadingType[];
    sensorReadingTypeNames: string;
    checked: boolean;
    searched?: boolean;
    name?: string;
    type?: string;
    referenceInfo?: string;
    inlineEdited?: boolean;
    nameRevert?: string;
    brandRevert?: string;
    source?: SensorSource;
    modifiedDate: Date;
    
    gpsLocation?: GpsInfo;

    last1HourIngestCount?: number;
    last4HoursIngestCount?: number;
    last24HoursIngestCount?: number;
    sensorReadingInfos?: SensorReadingInfo[];
    loadStatus?: string;

    userGroupId: number;
    userGroup?: string;
    userAccess?: UserAccessType;
    userName: string;
    userFeatureAccess?: { [key: string] : boolean }
    displayedOwner?: string;

    sensorCalibrationHistory: SensorCalibrationHistory[];
    activeCalibration?: SensorCalibrationHistory;

    notes?: string;
    virtualSensor: VirtualSensor;
    //virtualConfig?: VirtualSensorConfig;
    lastReading?: LastSensorReading;

    ignore?: boolean;
    ignoreUntil?: Date;
    ignoreDuration?: string;
    ignoreShowOptions?: boolean;

    searchResults?: { [key: string] : string }
    searchResultsSummary?: string;
    associatedsensorGroupNames?: string;

    isNew?: boolean;
    gpsStartDate?: Date;
    gpsEndDate?: Date;
}

export interface LastSensorReading {
    sensorId: number;
    isLoaded: boolean;
    date: Date;
    displayColor: string;
    waitingForLoad: boolean;
}

export interface SensorInfo {
    id: number;
    uuid: string;
    name: string;
    type: string;
    referenceInfo: string;
    source: SensorSource;
    sensorReadingTypes: SensorReadingType[];
    sensorCalibrationHistory?: SensorCalibrationHistoryInfo[];
    userGroupId: number;
    userName: string;
    modifiedDate: Date;
    gpsLocation: GpsInfo;
    notes: string;

    virtualSensorInfo: VirtualSensor;

    lastReading?: LastSensorReading;

    ignore?: boolean;
    ignoreUntil?: Date;

    searchResults?: { [key: string] : string }
}

export enum SensorSource {
    Physical = "Physical",
    Virtual = "Virtual",
    Internal = "Internal"
}


export interface CalibrationEquation {
    id: number;
    name: string;
}

export interface CalibrationSetup {
    startDate: string;
    endDate: string;
    selectedReadingType: SensorReadingType;
    selectedEquation: CalibrationEquation;
    //sensors: Sensor[];
    chartData: ChartData[];
}

export interface VirtualSensorReference {
    id: number;
    refName: string;
    sensorName: string;
    readingType: string;
    sensorId: number;
    readingTypeId: number;
    testValue: number;
    useLastXReadings: number;           // combine last x minutes of data for a given virtual reading
    useLastXAggr: string;               // combine options:  add, avg, med, max, min
}

export interface VirtualSensor {
    id: number;
    parentSensorId: number;
    isDisabled: boolean;
    calculateFreq: number;
    calculateDelay: number;
    calculateHourOfDay: number;
    calculateMinuteOfHour: number;
    functions: VirtualSensorFunction[];
    parameters: VirtualSensorParameter[];
}

export interface VirtualSensorParameter {
    id: number;
    virtualSensorId: number;
    name: string;
    sensorId: number;
    readingTypeId: number;
    testValue: number;
    useLastXReadings: number;           // combine last x minutes of data for a given virtual reading
    useLastXAggr: string;               // combine options:  count, avg, med, max, min

    sensorName: string;
    readingType: string;
}

export interface VirtualSensorFunction {
    id: number;
    virtualSensorId: number;
    equation: string;
    readingType: string;
    testResults: string;
}

export interface VirtualSensorConfig {
    isDisabled: boolean;
    calculateFreq: number;
    calculateDelay: number;
    calculateHourOfDay: number;
    calculateMinuteOfHour: number;
    functions: VirtualSensorFunction[];
    parameters: VirtualSensorParameter[];
}


export interface SensorSearchCriteria {
    searchText: string;
    maxResultsCount: number; 
}

export interface SensorSearchCriteria3 {
    sensorIds: number[];
    searchConditions: SensorSearchCondition[];
    searchResultsCountLimit: number;
}

export interface SensorReadingCriteria {
    sensorId: number;
    startDate: string;
    endDate: string;
    timeZoneDisplay: TimeZoneDisplay;
    timeZoneOffset: number;
    sensorReadingTypes?: SensorReadingType[];
}

export interface SensorReadingCriteria2 {
    sensorIds: number[];
    startDate: string;
    endDate: string;
    timeZoneDisplay: TimeZoneDisplay;
    timeZoneOffset: number;
    sensorReadingTypes?: SensorReadingType[];
}

export interface SensorReadingUpdateCriteria {
    sensorId: number;
    gpsLocation: GpsInfo;
    startDate: Date;
    endDate: Date;
}
